import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import useNetwork from 'hooks/useNetwork';
import OfflineView from 'components/Common/OfflineView';
import { recaptchaKey } from 'services/request';
import useLogout from 'hooks/useLogout';

const OtpComponent = dynamic(() => import('components/Account/OtpComponent'));
const Onboarding = dynamic(() => import('components/Account/Onboarding'));
const LoginWithOtpSecondStep = dynamic(
  () => import('components/Account/LoginWithOtpSecondStep'),
);

const ForgetPasswordSecondStep = dynamic(
  () => import('components/Account/ForgetPasswordSecondStep'),
);

const LoginWithPassword = dynamic(
  () => import('components/Account/LoginWithPassword'),
);

const AccountPages: React.FC = () => {
  const router = useRouter();
  const isOnline = useNetwork();
  useLogout();

  const tabs = {
    'forget-password': <OtpComponent />,
    'forget-password-second-step': <ForgetPasswordSecondStep />,
    login: <LoginWithPassword />,
    onboarding: <Onboarding />,
    'login-otp-second-step': <LoginWithOtpSecondStep />,
    'login-otp': <OtpComponent isLogin />,
  };

  return isOnline !== false ? (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
      {tabs[router.query.tabName as string]}
    </GoogleReCaptchaProvider>
  ) : (
    <OfflineView />
  );
};

export default AccountPages;

export const getStaticPaths: GetStaticPaths = () => {
  const paths = [
    { params: { tabName: 'change-password' } },
    { params: { tabName: 'forget-password' } },
    { params: { tabName: 'forget-password-second-step' } },
    { params: { tabName: 'login' } },
    { params: { tabName: 'onboarding' } },
    { params: { tabName: 'login-otp' } },
    { params: { tabName: 'login-otp-second-step' } },
  ];
  return { paths, fallback: false };
};

export const getStaticProps: GetStaticProps = async () => ({ props: {} });
